import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CampaignService } from '../../../../../services/campaign/campaign.service';
import { Campaign } from '../../campaign';


@Component({
  selector: 'campaign-segments',
  templateUrl: 'campaign-segments.html',
})
export class CampaignSegmentsComponent {

  @Input() campaign: Campaign;
  @Input() savedCategories: any[];
  @Input() returnedSavedCategories: any[];
  @Input() savedProductCouponsF: any[];
  @Input() savedProductCouponsNF: any[];
  @Input() returnedSavedProductCouponsF: any[];
  @Input() returnedSavedProductCouponsNF: any[];

  @Output() returnedSavedCategoriesEmitter: EventEmitter<any[]> = new EventEmitter();
  @Output() returnedSavedProductCouponsFemitter: EventEmitter<any[]> = new EventEmitter();
  @Output() returnedSavedProductCouponsNFemitter: EventEmitter<any[]> = new EventEmitter();

  public segments: Array<any>;


  constructor(private campaignService: CampaignService) {

  }

  ngOnInit()
  {
    this.campaign.segments = this.campaign.segments || [];
    this.segments = this.segments || [];

    if(this.segments.length > 0) {
      return;
    }

    if(this.campaign.getSegments) {
      this.segments = this.campaign.getSegments;
      return;
    }

    this.campaignService.getSegments().subscribe(res => {
      this.segments = res;
      this.campaign.getSegments = res;
    });

    if(this.campaign.segments.length == 0) {
      this.campaignService.getSegmentSuggestions(this.campaign.name).subscribe(res => {
        for (let segmentCode of res) {
          this.toggleSegment(segmentCode, false);
        }
        this.setCampaignSegments();
      });
    }
  }

  toggleSegment(segmentCode: string, save: boolean = true)
  {
    const index = this.campaign.segments.indexOf(segmentCode);

    if(index === -1) {
      this.campaign.segments.push(segmentCode);
    } else {
      this.campaign.segments.splice(index, 1);
    }

    if(save) {
      this.setCampaignSegments();
    }
  }

  isSelected(segmentCode)
  {
    return this.campaign.segments.indexOf(segmentCode) !== -1;
  }

  setCampaignSegments()
  {
    this.campaignService.setCampaignSegments(this.campaign.name, this.campaign.segments).subscribe(res => {});
  }

  ngOnDestroy() {
    if (this.returnedSavedCategories[0] && this.returnedSavedCategories[0].length > 0 && this.returnedSavedCategories[1] == "step5") {
      this.returnedSavedCategoriesEmitter.emit(this.returnedSavedCategories);
    } else if (this.savedCategories.length > 0) {
      this.returnedSavedCategoriesEmitter.emit([this.savedCategories, "tab"]);
    }

    if (this.returnedSavedProductCouponsF.length == 0 && this.savedProductCouponsF.length > 0) {
      this.returnedSavedProductCouponsFemitter.emit(this.savedProductCouponsF);
    }

    if (this.returnedSavedProductCouponsNF.length == 0 && this.savedProductCouponsNF.length > 0) {
      this.returnedSavedProductCouponsNFemitter.emit(this.savedProductCouponsNF);
    }

  }



}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/segments/campaign-segments.component.ts